import React from 'react';
import PropTypes from 'prop-types';

const FlowWise = ({ fill = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3478_39608"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3478_39608)">
      <path
        d="M11.5001 19.0006L5.00036 15.5006C4.80508 15.3856 4.11864 15.049 4.11864 14.8212V7.85422C4.11864 7.35952 4.07256 6.75103 4.5 6.99838L12.0538 10.8115C12.2556 10.9287 12.3771 11.1435 12.3749 11.3757L12.2773 18.3665C12.2708 18.859 11.7349 19.1606 11.3096 18.9111L11.5001 19.0006Z"
        stroke={fill || '#6930CA'}
        strokeWidth="1.2"
      />
      <path
        d="M15 9.00053L8.19418 12.6354C7.8275 12.8437 7.37402 12.579 7.37402 12.1581V4.95459C7.37402 4.75498 7.48251 4.57055 7.65826 4.47291L14.5 0.999416C14.8623 0.799802 15.3698 1.08008 15.3763 1.49233L15.5 8.50053C15.5043 8.70014 15.1757 8.90289 15 9.00053Z"
        stroke={fill || '#6930CA'}
        strokeWidth="1.2"
      />
      <path
        d="M7.71338 12.668V8.59766L11.241 10.7782L7.71338 12.668Z"
        fill={fill || '#6930CA'}
        stroke={fill || '#6930CA'}
        strokeWidth="0.271356"
      />
    </g>
  </svg>
);

FlowWise.propTypes = {
  fill: PropTypes.string,
};

export default FlowWise;
